module.exports = __webpack_public_path__ + "img/pitch-deck.26db5217.svg";